export { MoreInfo } from './MoreInfo';
